module.exports = __webpack_public_path__ + "media/images/country_flags/st-e83467a9150d8dc8b3cab8721d919fcc.png";